import { connect } from 'react-redux'
import { map, get } from 'lodash'
import pluralize from 'pluralize'
import { getEntity } from '../../../selectors/data/entity_selectors'
import { getCurrentUser } from '../../../selectors/data/user_selectors'
import ResourceActions from '../components/ResourceActions'
import LinkAction from '../components/actions/LinkAction'
import PublishAction from '../components/actions/PublishAction'
import ShareAction from '../components/actions/ShareAction'
import ReadPermissionsAction from '../components/actions/ReadPermissionsAction'
import { ResourceActionsContainerProps, ActionObjectType } from '../types'
import { RootState } from '@store/store'

type ResourcePathMap = {
  [key: string]: string
}

const getDefaultActionObjects = (
  resourceType: string,
  resourceId: number | string,
  entity: object
): Record<string, ActionObjectType> => {
  const resourcePathMapping: ResourcePathMap = {
    Table: `/projects/${resourceId}`,
    default: `/${pluralize(resourceType).toLowerCase()}/${resourceId}`,
  }
  const resourceBasePath = resourcePathMapping[resourceType] || resourcePathMapping['default']

  return {
    read: {
      ability: 'read',
      key: 'standard-read',
      component: LinkAction,
      props: {
        text: 'View',
        href: resourceBasePath,
      },
    },
    edit: {
      ability: 'edit',
      key: 'standard-edit',
      component: LinkAction,
      props: {
        text: 'Edit',
        href: `${resourceBasePath}/edit`,
      },
    },
    print: {
      ability: 'read',
      key: 'standard-print',
      component: LinkAction,
      props: {
        text: 'Print',
        href: `${resourceBasePath}?print=1`,
      },
    },
    permissions: {
      ability: 'read_permissions',
      key: 'read-permissions',
      component: ReadPermissionsAction,
      props: {
        resourceId,
        resourceType,
        onDone: () => {
          // TODO
        },
      },
    },
    moderate: {
      ability: 'moderate',
      key: 'standard-moderate',
      component: LinkAction,
      props: {
        text: 'Moderate',
        href: `${resourceBasePath}/moderate`,
      },
    },
    destroy: {
      ability: 'destroy',
      key: 'standard-destroy',
      component: LinkAction,
      props: {
        text: 'Delete',
        href: resourceBasePath,
        method: 'delete',
        confirm: {
          title: 'Are you sure?',
          message: "Are you sure you want to delete this? This can't be undone.",
        },
      },
    },
    publish: {
      ability: 'publish',
      key: 'standard-publish',
      component: PublishAction,
      props: {
        resourceId,
        resourceType,
        entity,
      },
    },
    share: {
      ability: 'share',
      key: 'standard-share',
      component: ShareAction,
      props: {
        resourceId,
        resourceType,
      },
    },
  }
}

const mapStateToProps = (state: RootState, props: ResourceActionsContainerProps) => {
  const { title, customTrigger, resourceId, resourceType, wantedActions } = props

  if (!resourceType) {
    console.error('ResourceActionsContainer: resourceType is required')
  }
  if (!resourceId) {
    console.error('ResourceActionsContainer: resourceId is required')
  }

  const currentUser = getCurrentUser(state)
  const entity = getEntity(state, {
    entityId: resourceId,
    entityType: resourceType,
  })

  if (!entity) {
    console.error('ResourceActionsContainer: entity not found')
  }

  const defaultActionObjects = getDefaultActionObjects(resourceType, resourceId, entity)
  const actionObjects = map(wantedActions, (action: string | ActionObjectType) => {
    if (typeof action === 'string') {
      return get(defaultActionObjects, [action]) as ActionObjectType | undefined
    }
    return action as ActionObjectType
  }).filter(Boolean) as ActionObjectType[]

  if (false) {
    console.log('Remapped action objects:', actionObjects)
    console.log('ResourceActionsContainer found entity', entity)
  }

  return {
    title,
    customTrigger,
    resourceId,
    resourceType,
    currentUser,
    entity,
    actionObjects,
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceActions)
